import { HttpError } from '@luminovo/api-contracts';
import { createFileRoute, notFound } from '@tanstack/react-router';
import type { JSX } from 'react';

import { OfferImportDetailsPage } from '@/areas/offers/OfferImports/OfferImportDetailsPage';
import { offerImportContextQuery } from '@/domain/offerImportContext/offerImportContextHandler';
import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// Only the new navigation has this page: no route of today's leads here. An import the API doesn't know, such as one
// deleted since, renders the not-found page. `fetchQuery`, not `ensureQueryData`: Back to a deleted import would
// otherwise show it from the cache.
export const Route = createFileRoute('/_authenticated/next/offer-imports/$offerImportId')({
    staticData: { access: { permissions: canViewPartLibrarySourcing }, chrome: 'none' } satisfies PageStaticData,
    loader: async ({ context: { queryClient }, params: { offerImportId } }) => {
        await queryClient.fetchQuery(offerImportContextQuery(offerImportId)).catch((error: unknown) => {
            throw error instanceof HttpError && error.status === 404 ? notFound() : error;
        });
    },
    component: RouteComponent,
    remountDeps: ({ params }) => params.offerImportId,
});

function RouteComponent(): JSX.Element {
    const { offerImportId } = Route.useParams();
    return <OfferImportDetailsPage offerImportId={offerImportId} />;
}
